import { formatLicensePlate, formatLocaleNumber } from "@/utils/formatUtils";
import { isDefined } from "@/utils/utils";
import { t } from "i18next";
import { Bodywork, FuelType, Transmission, VehicleCategory } from "../../../../modules/contract/enums";
import { Vehicle } from "../../../../modules/contract/types";
import { DateHistoryItem, EmptyHistoryItem } from "./commonHistoryItems";

const VehicleCategoryHistoryItem = (value?: VehicleCategory) =>
  value ? <span>{t("contract.enums.vehicleCategory." + value)}</span> : <EmptyHistoryItem />;

const FuelTypeHistoryItem = (value?: FuelType) =>
  value ? <span>{t("contract.enums.fuelType." + value)}</span> : <EmptyHistoryItem />;

const TransmissionHistoryItem = (value?: Transmission) =>
  value ? <span>{t("contract.enums.transmission." + value)}</span> : <EmptyHistoryItem />;

const BodyworkHistoryItem = (value?: Bodywork) =>
  value ? <span>{t("contract.enums.bodywork." + value)}</span> : <EmptyHistoryItem />;

const LicensePlateHistoryItem = (value?: string) =>
  value ? <span>{formatLicensePlate(value)}</span> : <EmptyHistoryItem />;

const EngineDisplacementHistoryItem = (value?: number) =>
  isDefined(value) ? (
    <span>
      {formatLocaleNumber(value)} cm<sup>3</sup>
    </span>
  ) : (
    <EmptyHistoryItem />
  );

const EnginePowerHistoryItem = (value?: number) =>
  isDefined(value) ? (
    <span>
      {formatLocaleNumber(value)} {t("common.sign.enginePower")}
    </span>
  ) : (
    <EmptyHistoryItem />
  );

const TotalWeightHistoryItem = (value?: number) =>
  isDefined(value) ? (
    <span>
      {formatLocaleNumber(value)} {t("common.sign.kg")}
    </span>
  ) : (
    <EmptyHistoryItem />
  );

export const VehicleHistoryItemsMap = new Map<Partial<keyof Vehicle>, (value: any) => React.JSX.Element>([
  ["category", VehicleCategoryHistoryItem],
  ["licensePlate", LicensePlateHistoryItem],
  ["firstRegistrationDate", DateHistoryItem],
  ["engineDisplacement", EngineDisplacementHistoryItem],
  ["enginePower", EnginePowerHistoryItem],
  ["electricEnginePower", EnginePowerHistoryItem],
  ["fuelType", FuelTypeHistoryItem],
  ["transmission", TransmissionHistoryItem],
  ["bodywork", BodyworkHistoryItem],
  ["totalWeight", TotalWeightHistoryItem],
]);
